export default __webpack_public_path__ + "static/media/sample-product-1.3c599245.png";